import React from 'react';
import BarChart from '../../ui/BarChart';

const PendingIssuesChart = ({ data = [], labels = null, onExpand }) => {
  // Convert array of numbers to array of objects with value property
  const chartData = data.map(value => ({ value }));

  // Always show the chart structure, even with empty data
  return (
    <BarChart
      data={chartData}
      labels={labels}
      title="Pending Issues"
      xAxisLabel="Sites"
      yAxisLabel="Total No.of Issues"
      barColor="#22c55e"
      onExpand={onExpand}
      className="h-80"
    />
  );
};

export default PendingIssuesChart;
